import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';

var ListBody = function (_a) {
    var children = _a.children, _b = _a.childrenForFishingEmpty, childrenForFishingEmpty = _b === void 0 ? null : _b, onScroll = _a.onScroll, rest = __rest(_a, ["children", "childrenForFishingEmpty", "onScroll"]);
    return (React.createElement("div", { className: 'bottom-of-lists-wrapper' },
        React.createElement("div", __assign({ className: 'scrollable-container', onScroll: onScroll }, rest),
            childrenForFishingEmpty,
            React.createElement("div", { className: "list-item-rows-container ".concat(childrenForFishingEmpty ? 'for-fishing' : '') }, children))));
};
var ListBodyFishingEmpty = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'fishing-result-empty-content' }, children);
};

export { ListBody, ListBodyFishingEmpty };
